import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// ui
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import { useTranslation, Trans } from 'react-i18next';

// style
import { styles } from './style';

const useStyles = makeStyles(styles);

const day = [<Trans>วันนี้</Trans>, <Trans>พรุ่งนี้</Trans>, <Trans>มะรืนนี้</Trans>];
const colorRainfallForecast = ['#bdbdbd', '#add4ff', '#69c902', '#FE8A15', '#ff2e04'];
const colorRainfallText = ['#000', '#000', '#000', '#000', '#FFF', '#FFF'];

export default function ForecastRainfall(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [error, setError] = useState('');
  const [data, setData] = useState([]);
  const { currentArea } = props;

  function getRainfallColor(txt) {
    let color;

    if (txt === 'ไม่มีฝน') {
      color = [colorRainfallForecast[0], colorRainfallText[0]];
    } else if (txt === 'ฝนเล็กน้อย') {
      color = [colorRainfallForecast[1], colorRainfallText[1]];
    } else if (txt === 'ฝนปานกลาง') {
      color = [colorRainfallForecast[2], colorRainfallText[2]];
    } else if (txt === 'ฝนหนัก') {
      color = [colorRainfallForecast[3], colorRainfallText[3]];
    } else if (txt === 'ฝนหนักมาก') {
      color = [colorRainfallForecast[4], colorRainfallText[4]];
    } else color = [colorRainfallForecast[0], colorRainfallText[0]];

    return color;
  }

  useEffect(() => {
    const fetchData = async () => {
      let param = '';

      if (currentArea.code !== '0') {
        param = `?province_code=${currentArea.code}`;

        fetch(`${process.env.REACT_APP_API_URL}/provinces/wrfrom_rainforcase7d${param}`)
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('Something went wrong ...');
          })
          .then((result) => {
            setData(result.data.slice(0, 3));
          })
          .catch((err) => setError(err));
      } else {
        setData([]);
        return null;
      }
    };

    fetchData();
  }, [currentArea]);

  return (
    <>
      {error && <div>Error Occured</div>}
      <Box p={2} className={classes.boxContent}>
        <Box pb={2} className={classes.title} alignItems="center">
          {t('คาดการณ์ฝน')} (
          {t(currentArea.name)}
          )
        </Box>
        {currentArea.code !== '0' && (
          <Grid container spacing={2}>
            {data.map((d, i) => {
              const statusColor = getRainfallColor(d.rainfall_text);

              return (
                <Fragment key={d.forecast_datetime}>
                  <Grid item xs={5} align="right">{day[i]}</Grid>
                  <Grid item xs={7}>
                    <Tooltip title={d.forecast_datetime.split(' ')[0]} aria-label="add">
                      <Box
                        p={1}
                        className={`${classes.statusBox}`}
                        style={{ backgroundColor: statusColor[0] }}
                        align="center"
                        id="rainfall_text_data"
                      >
                        <span style={{ color: statusColor[1] }}>
                          {t(d.rainfall_text)}
                        </span>
                      </Box>
                    </Tooltip>
                  </Grid>
                </Fragment>
              );
            })}
          </Grid>
        )}
      </Box>
    </>
  );
}

ForecastRainfall.propTypes = {
  // currentMode: PropTypes.string.isRequired,
  currentArea: PropTypes.instanceOf(Object).isRequired,
};
